import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { getStorageKey } from '@cleverlist/utils';
let customStorage;
export function setAuthStorage(storage) {
    customStorage = storage;
}
export const useAuthStore = create()(persist((set) => ({
    user: null,
    token: null,
    isAuthenticated: false,
    isLoading: true,
    setAuth: (user, token) => set({
        user,
        token,
        isAuthenticated: true,
        isLoading: false,
    }),
    clearAuth: () => set({
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: false,
    }),
    setLoading: (loading) => set({ isLoading: loading }),
    updateUser: (updates) => set((state) => ({
        user: state.user ? { ...state.user, ...updates } : null,
    })),
}), {
    name: getStorageKey('auth'),
    storage: createJSONStorage(() => customStorage ?? localStorage),
    partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
    }),
    onRehydrateStorage: () => (state) => {
        state?.setLoading(false);
    },
}));
